import ClassHelper from '../ClassHelper';

class RefundPaymentPassengers extends ClassHelper {
  constructor({ passenger, amount, useRefundPolicy, removePassenger } = {}) {
    super(...arguments);
    this.passenger = passenger;
    this.amount = amount;
    this.useRefundPolicy = !!useRefundPolicy;
    this.removePassenger = !!removePassenger;
  }
}

export default RefundPaymentPassengers;